import { render, staticRenderFns } from "./UserDetail.vue?vue&type=template&id=3f4912b6&scoped=true&"
import script from "./UserDetail.vue?vue&type=script&lang=js&"
export * from "./UserDetail.vue?vue&type=script&lang=js&"
import style0 from "./UserDetail.vue?vue&type=style&index=0&id=3f4912b6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4912b6",
  null
  
)

export default component.exports